<app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>
<div class="content-wrapper">
    <div class="box">
        <form (ngSubmit)="onSubmit()" [formGroup]="SearchRequistion">
            <mat-card class="btnCard">
                <mat-card-actions>

                    <button class="btn-primary1" mat-stroked-button type="button" (click)="onSubmit()">Get Result</button>
                   
                    <button class="btn-primary1" type="button" (click)="Exit()" mat-stroked-button>Exit</button>
                    <button class="btn-primary1" mat-stroked-button type="button" (click)="ResetData()">Reset</button>
                    <button class="btn-primary1" mat-stroked-button type="button" (click)="GetResult()">Download Report</button>
                </mat-card-actions>
             
            </mat-card>
            <div class="cardSearch">
                <div class="card-header form-control" data-bs-toggle="collapse" href="#collapseSearch" role="button"
                    aria-expanded="false" aria-controls="collapseSearch">
                    <header class="panel-heading">
                        <b class="panel-title">Search(Tap to Expand)</b>
                        <span  style="float:right"><i class="pi pi-arrow-down"></i></span>
                    </header>
                </div>
                <div class="collapse" style="margin: 5px;" id="collapseSearch">
                        <div class="row">
                            <div class="mb-3 col-md-6">
                                <label >GTC ID</label>
                                <input type="text" placeholder="Enter GTC ID"
                                class="form-control" formControlName="GTCNumber" />

                            </div>
                            <div class="mb-3 col-md-6">
                                <label style="margin-right: 30px;">Entity Name</label>
                                <p-dropdown [options]="entityNameList"
                                [showClear]="true"
                                placeholder="Select Entity Name"
                                formControlName="FirmId"
                                ></p-dropdown>
                            </div>

                          
                            
                        </div>
                        <div class="row">
                            <div class="mb-3 col-md-6">
                                <label>Engagement Manager Name</label>
                                <input type="text" placeholder="Enter Manager Name"
                                class="form-control" formControlName="EngManagerName" />

                            </div>
                            <div class="mb-3 col-md-6">
                                <label >Engagement Partner Name</label>
                                <input type="text" placeholder="Enter Partner Name"
                                class="form-control" formControlName="EngPartnerName" />

                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-md-6">
                                <label>From Date</label>
                                <div class="input-group ">
                                    <input readonly [matDatepicker]="RequisitionFromDatePicker"
                                        formControlName="FromDate" class="form-control"
                                        placeholder="Requisition Date" ng-model-options="{timezone: 'UTC'}" #ref
                                      >
                                    <mat-datepicker-toggle class="input-group-addon iconWithInput" matSuffix
                                        [for]="RequisitionFromDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker touchUi="true" #RequisitionFromDatePicker></mat-datepicker>
                                </div>
                            </div>
                            <div class="mb-3 col-md-6">
                                <label>To Date</label>
                                <div class="input-group ">
                                    <input readonly [matDatepicker]="RequisitionToDatePicker"
                                        formControlName="ToDate" class="form-control"
                                        placeholder="Requisition Date" ng-model-options="{timezone: 'UTC'}"
                                        [min]="toDate">
                                    <mat-datepicker-toggle class="input-group-addon iconWithInput" matSuffix
                                        [for]="RequisitionToDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker touchUi="true" #RequisitionToDatePicker></mat-datepicker>
                                </div>
                            </div>
                        </div>
                    
                    </div>
                  
              
            </div>

            <div class="mat-elevation-z12" style="margin: 10px;">
                <div class="table-container">
                    <table mat-table [dataSource]="dataSource" matSort
                    matSortActive="created" matSortDisableClear matSortDirection="asc">
                     
                
                        <ng-container matColumnDef="GTCNumber" sticky>
                            <th style="background-color: #B8BCBC;border-bottom: 2px solid yellow; border-right: 1px solid black;" mat-header-cell *matHeaderCellDef>GTC Number</th>
                            <td mat-cell *matCellDef="let row">{{row.GTCNumber}}</td>
                        </ng-container>
                        <ng-container matColumnDef="EntityName">
                            <th style="background-color: #B8BCBC;border-bottom: 2px solid yellow; border-right: 1px solid black;" mat-header-cell *matHeaderCellDef>Entity Name</th>
                            <td mat-cell *matCellDef="let row">{{row.EntityName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="EngPartnerName">
                            <th style="background-color: #B8BCBC;border-bottom: 2px solid yellow; border-right: 1px solid black;" mat-header-cell *matHeaderCellDef>Eng Partner Name</th>
                            <td mat-cell *matCellDef="let row">{{row.EngPartnerName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="EngManagerName">
                            <th style="background-color: #B8BCBC;border-bottom: 2px solid yellow; border-right: 1px solid black;" mat-header-cell *matHeaderCellDef>Eng Manager Name</th>
                            <td mat-cell *matCellDef="let row">{{row.EngManagerName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="StatusName">
                            <th style="background-color: #B8BCBC;border-bottom: 2px solid yellow; border-right: 1px solid black;" mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let row">{{row.StatusName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="CreatedBy">
                            <th style="background-color: #B8BCBC;border-bottom: 2px solid yellow; border-right: 1px solid black;" mat-header-cell *matHeaderCellDef>CreatedBy</th>
                            <td mat-cell *matCellDef="let row">{{row.CreatedBy}}</td>
                        </ng-container>
                        <ng-container matColumnDef="CreatedOn">
                            <th style="background-color: #B8BCBC;border-bottom: 2px solid yellow; border-right: 1px solid black;" mat-header-cell *matHeaderCellDef>Request Date</th>
                            <td mat-cell *matCellDef="let row">{{row.CreatedOn | date:'dd/MMM/yyyy'}}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"  (click)="onGetDataResult(row)"></tr>
                    </table>
                </div>
            </div>
           
        </form>
        <mat-paginator #paginator [length]="_global.length" [pageIndex]="_global.pageIndex" [pageSize]="_global.RecordSize"
        [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPaginateChange($event)">
      </mat-paginator>
        <!-- <mat-paginator [length]="length" (page)="onPaginateChange($event)"></mat-paginator>
        <div style="float:right;">Page : <input type="text" numbersOnly style="width:50px;height:10px;"
                [(ngModel)]="pageIndex" /> of {{totalPage}} &nbsp;&nbsp;&nbsp;&nbsp;<button type="button"
                mat-stroked-button (click)="GoToPage()">Go</button></div> -->
    </div>
    
</div>

